import { FormControl, TextField } from '@mui/material';
import FieldInfo from 'app/common/components/field-info';
import Widget from 'app/common/components/widgets/widget';
import type { StringWidgetHookProps } from './string-widget-hook.js';

export function StringInput({
  label,
  error,
  value,
  isRequired,
  disabled,
  readOnly,
  handleChange,
  onBlur,
  description,
  maxLength,
  id
}: StringWidgetHookProps) {
  return (
    <FormControl
      fullWidth
      variant="outlined"
      error={Boolean(error)}
      disabled={Boolean(disabled) || Boolean(readOnly)}
      required={isRequired}
    >
      <TextField
        size="small"
        label={label}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        required={isRequired}
        error={Boolean(error)}
        disabled={Boolean(disabled) || Boolean(readOnly)}
        inputProps={{
          'data-testid': `${id}__input`,
          maxLength
        }}
      />
      <FieldInfo description={description} error={error} />
    </FormControl>
  );
}

export function StringWidget(props: StringWidgetHookProps) {
  return (
    <Widget testId={props.id}>
      <StringInput {...props} />
    </Widget>
  );
}
